import axios from '../utils/axios';

/**
 * 查询自定义印章认证信息和状态  /seal/diy/seal/getDiySealAuthenticationlInfo
 * @param {*} data
 * @param {*} au
 */
export function getDiySealAuthenticationlInfo(data, au) {
  return axios('/ttd-fund-user/seal/diy/seal/getDiySealAuthenticationlInfo', data, au);
}
/**
 * 自定义自然人身份认证  http://192.168.88.120:200/index.php?s=/17&page_id=1679
 * @param {*} data
 * @param {*} au
 */
export function authentication(data, au) {
  return axios('/ttd-fund-user/seal/diy/seal/authentication', data, au);
}
